import { render } from "./LeadCreation.vue?vue&type=template&id=28c580ec&ts=true"
import script from "./LeadCreation.vue?vue&type=script&lang=ts"
export * from "./LeadCreation.vue?vue&type=script&lang=ts"

import "./LeadCreation.vue?vue&type=style&index=0&id=28c580ec&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__